/*
 * TL Exit-Intent Help bridge  (Klaviyo "Exit-Intent Help" form  <->  Gorgias chat)
 * ---------------------------------------------------------------------------------
 * Source of truth: email-marketer repo build/forms/assets/gorgias-help-bridge.js
 * The Klaviyo form (build_help_exit.py) renders three CTA anchors:
 *   Chat   <a href=".../?tl-help=chat#tl-help-chat">
 *   Call   <a href="tel:...">
 *   Email  <a href="mailto:...">
 *
 * This snippet owns the things Klaviyo can't:
 *   1) Office hours (Mon-Fri 9-5 PT): the popup only appears in-hours. Out-of-hours
 *      a MutationObserver hides our form the instant Klaviyo inserts it (before the
 *      browser paints, so there's no flash). In-hours, all three CTAs show.
 *   2) Opening Gorgias from the Chat click: window.GorgiasChat.open().
 *
 * It keys off the href (class/id/data attrs get stripped by Klaviyo's html_text
 * sanitizer; the href is preserved), and works whether Klaviyo renders the form
 * inline in the page DOM (click delegation) or the click navigates (?tl-help=chat
 * param fallback).
 *
 * CONFIG: set PHONE_TZ / OPEN_HOUR / CLOSE_HOUR / OPEN_DAYS to match the Gorgias
 * office hours. Defaults mirror the storefront footer ("Mon-Fri 9am-5pm PST").
 */
(function () {
  "use strict";

  var PHONE_TZ   = "America/Los_Angeles"; // Pacific (handles PST/PDT automatically)
  var OPEN_HOUR  = 9;                      // 9am
  var CLOSE_HOUR = 17;                     // 5pm (exclusive)
  var OPEN_DAYS  = [1, 2, 3, 4, 5];        // Mon..Fri

  // ---- availability -------------------------------------------------------
  function withinHours() {
    try {
      var parts = new Intl.DateTimeFormat("en-US", {
        timeZone: PHONE_TZ, weekday: "short", hour: "numeric", hour12: false
      }).formatToParts(new Date());
      var map = {};
      parts.forEach(function (p) { map[p.type] = p.value; });
      var dayIdx = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[map.weekday];
      var hour = parseInt(map.hour, 10) % 24;
      return OPEN_DAYS.indexOf(dayIdx) !== -1 && hour >= OPEN_HOUR && hour < CLOSE_HOUR;
    } catch (e) {
      return true; // fail open: if the clock check throws, prefer showing chat
    }
  }

  function openGorgias() {
    if (window.GorgiasChat && typeof window.GorgiasChat.open === "function") {
      window.GorgiasChat.open();
      return true;
    }
    return false;
  }

  // ---- show / hide the right CTA on the rendered form ---------------------
  // Find the help form's anchors by href and toggle Chat vs Email by hours.
  function applyHours(root) {
    var open = withinHours();
    var scope = root || document;
    var anchors = scope.querySelectorAll('a[href*="tl-help=chat"], a[href^="mailto:"], a[href^="tel:"]');
    anchors.forEach(function (a) {
      var href = a.getAttribute("href") || "";
      if (href.indexOf("tl-help=chat") !== -1) {
        a.style.display = open ? "block" : "none";   // Chat: in-hours only
      }
      // mailto: (Email) and tel: (Call) are left untouched — always visible.
    });
  }

  // Open the shared "Send Us a Message" modal (#tl-contact-modal, native <dialog>).
  // Rendered on product pages by the buybox and site-wide by tl-contact-modal-global.
  function openContactModal() {
    var m = document.getElementById("tl-contact-modal");
    if (m && typeof m.showModal === "function") {
      if (!m.open) m.showModal();
      return true;
    }
    return false;
  }

  // Is this anchor one of OUR popup's CTAs (inside a Klaviyo form), not a site-chrome
  // link (e.g. the footer's mailto)? Keeps the email-modal swap scoped to the popup.
  function inKlaviyoForm(el) {
    return !!(el.closest && el.closest('[class*="klaviyo-form"], [class*="kl-private"]'));
  }

  // Walk up from a node inside the popup to the outermost Klaviyo container
  // (card + overlay), so we close the whole thing, not just the inner card.
  function klaviyoRootFrom(node) {
    var root = node.closest('[class*="klaviyo-form"], [class*="kl-private"]');
    if (!root) return null;
    var top = root, p = root.parentElement;
    while (p && /klaviyo|kl-private/i.test(p.className || "")) { top = p; p = p.parentElement; }
    return top;
  }

  // Dismiss the Klaviyo popup (CTA taken, or out-of-hours suppression). Prefer
  // Klaviyo's own close control so it records the close + releases the scroll lock;
  // fall back to hiding the whole container.
  function dismissPopup(node) {
    var top = klaviyoRootFrom(node);
    if (!top) return;
    var btn = top.querySelector(
      'button[aria-label*="lose"], [aria-label*="lose dialog"], button[class*="close"], [class*="close"][role="button"]'
    );
    if (btn) { try { btn.click(); return; } catch (e) {} }
    top.style.display = "none";
  }

  // ---- click bridge (fast path: no reload, form is inline in page DOM) ----
  document.addEventListener("click", function (e) {
    if (!e.target || !e.target.closest) return;

    // Chat -> Gorgias, then close the popup
    var chat = e.target.closest('a[href*="tl-help=chat"]');
    if (chat) {
      if (openGorgias()) {
        e.preventDefault();        // opened chat in place; don't navigate
        e.stopPropagation();
      }
      dismissPopup(chat);          // close the exit popup behind it
      return;                      // (if Gorgias wasn't ready, the param fallback reopens it)
    }

    // Email -> shared contact modal (only the popup's email link; footer mailto untouched)
    var email = e.target.closest('a[href^="mailto:"]');
    if (email && inKlaviyoForm(email)) {
      if (openContactModal()) {
        e.preventDefault();        // show the in-page form instead of the mail client
        e.stopPropagation();
      }
      dismissPopup(email);
      return;
    }

    // Call -> let the dialer open (don't preventDefault), but still close the popup
    var tel = e.target.closest('a[href^="tel:"]');
    if (tel && inKlaviyoForm(tel)) {
      dismissPopup(tel);
    }
  }, true);

  // ---- param fallback (slow path: the anchor navigated) -------------------
  function consumeParamFallback() {
    if (window.location.search.indexOf("tl-help=chat") === -1) return;
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      if (openGorgias() || tries > 40) {   // ~10s max (Gorgias loads async)
        clearInterval(t);
        // strip the param so a refresh doesn't reopen chat
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete("tl-help");
          url.hash = "";
          window.history.replaceState({}, document.title, url.pathname + url.search);
        } catch (e) {}
      }
    }, 250);
  }

  // ---- office-hours gate: hide the help popup before it ever paints --------
  // Out-of-hours, hide OUR Exit-Intent Help form the moment Klaviyo inserts it.
  // A MutationObserver fires on the DOM insertion (a microtask, before the browser
  // paints), so the form never becomes visible — no flash, no close animation.
  // Scoped to our form via its Chat CTA, so other Klaviyo forms (e.g. newsletter
  // signup) still work after hours. Idempotent + re-applies if Klaviyo re-shows it.
  function hideHelpForm() {
    var chat = document.querySelector('a[href*="tl-help=chat"]');
    if (!chat || !inKlaviyoForm(chat)) return;     // not our form; leave it alone
    var root = klaviyoRootFrom(chat);
    if (root && root.style.display !== "none") {
      root.style.setProperty("display", "none", "important");
    }
  }

  function gateHelpPopup() {
    if (withinHours()) return;                      // in-hours: let it show
    hideHelpForm();                                 // catch it if already present
    var obs = new MutationObserver(hideHelpForm);
    obs.observe(document.documentElement, {
      childList: true, subtree: true, attributes: true, attributeFilter: ["style", "class"]
    });
  }

  // In-hours, re-apply the right CTAs each time Klaviyo opens the help form.
  window.addEventListener("klaviyoForms", function (e) {
    if (!(e && e.detail)) return;
    if (e.detail.type !== "open" && e.detail.type !== "stepSubmit") return;
    if (!withinHours()) return;                     // out-of-hours handled by the gate
    var chat = document.querySelector('a[href*="tl-help=chat"]');
    if (chat && inKlaviyoForm(chat)) applyHours(document);
  });

  function init() {
    consumeParamFallback();
    gateHelpPopup();      // out-of-hours: arm the observer before Klaviyo injects
    applyHours(document);
    // Klaviyo injects the form a beat after load; re-apply shortly after.
    setTimeout(function () { applyHours(document); }, 1200);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
